import { render, staticRenderFns } from "./QScoreCards_EventsAll.vue?vue&type=template&id=15d6bca3&"
import script from "./QScoreCards_EventsAll.vue?vue&type=script&lang=js&"
export * from "./QScoreCards_EventsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports